/**
 * Route definitions for the join funnel. Pre-auth, static imports per
 * member-ui/CLAUDE.md ("Pre-auth routes stay static").
 *
 * Three variants × three steps. The variant slug is the second URL segment
 * (or absent for the default variant); steps 2 and 3 live at /profile and
 * /location underneath.
 *
 * URL shape:
 *   /join                            → default, Step 1
 *   /join/profile                    → default, Step 2
 *   /join/location                   → default, Step 3
 *   /join/test-before-test           → test-before-test, Step 1
 *   /join/test-before-test/profile   → test-before-test, Step 2
 *   /join/test-before-test/location  → test-before-test, Step 3
 *   /join/checkup                    → checkup, Step 1
 *   /join/checkup/profile            → checkup, Step 2
 *   /join/checkup/location           → checkup, Step 3
 *
 * We enumerate the three variants explicitly (rather than using `:variant`)
 * so that `/join/profile` cannot accidentally be interpreted as
 * `variant=profile`. The default variant's child paths and the named
 * variants' sibling paths must not collide.
 */

import type { RouteObject } from 'react-router-dom';
import { FunnelGuard } from './FunnelGuard';
import { JoinStep1 } from './steps/JoinStep1';
import { JoinStep2 } from './steps/JoinStep2';
import { JoinStep3 } from './steps/JoinStep3';

function variantBranch(pathSegment: string | null): RouteObject {
  const children: RouteObject[] = [
    { index: true, Component: JoinStep1 },
    { path: 'profile', Component: JoinStep2 },
    { path: 'location', Component: JoinStep3 },
  ];
  if (pathSegment === null) {
    // Default variant — children mount directly under /join via the parent index.
    return { path: '', Component: FunnelGuard, children };
  }
  return { path: pathSegment, Component: FunnelGuard, children };
}

export const routeJoinFunnel: RouteObject = {
  path: '/join',
  children: [
    variantBranch(null),
    variantBranch('test-before-test'),
    variantBranch('checkup'),
  ],
};
